<div class="loading-container">
  <div>
    <img src="../../../assets/img/afas-logo-white.jpg" alt="Automated Family Alert System" />
  </div>

  <h3>Logging You In...</h3>
  <mat-spinner></mat-spinner>
</div>
